import { render, staticRenderFns } from "./IndustryForm.vue?vue&type=template&id=fcb3d75e&lang=pug&"
import script from "./IndustryForm.vue?vue&type=script&lang=js&"
export * from "./IndustryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports